(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/number-selector/assets/javascripts/number-selector-button.js') >= 0) return;  svs.modules.push('/components/lb-ui/number-selector/assets/javascripts/number-selector-button.js');
"use strict";

const _svs$ui = svs.ui,
  Button = _svs$ui.Button,
  ReactIcon = _svs$ui.ReactIcon;
const NumberSelectorButton = _ref => {
  let ariaLabel = _ref.ariaLabel,
    classname = _ref.classname,
    icon = _ref.icon,
    isDisabled = _ref.isDisabled,
    size = _ref.size,
    onClick = _ref.onClick;
  const classNames = ['number-selector-button btn btn-300 btn-circle btn-inverted btn-icon btn-icon-center'];
  if (classname) {
    classNames.push(classname);
  }
  if (isDisabled) {
    classNames.push('disabled');
  }
  return React.createElement(Button, {
    "aria-label": ariaLabel,
    className: classNames.join(' '),
    "data-testid": "qa-btn-".concat(icon),
    onClick: onClick,
    type: "button"
  }, React.createElement(ReactIcon, {
    color: "fc-white",
    icon: icon,
    size: size
  }));
};
setGlobal('svs.components.lbUi.numberSelector.NumberSelectorButton', NumberSelectorButton);

 })(window);